// src/hooks/useUrlParams.js
//
// Estado de pantalla guardado en la URL (?q=...&pa=...). Sirve para que filtros,
// orden, vista y página sobrevivan a abrir una ficha y volver, a cambiar de
// sección y al botón Atrás del navegador. Un parámetro igual a su valor por
// defecto no se escribe, así la URL queda corta. Los parámetros ajenos al hook
// (por ejemplo `checks` o `tab`) se conservan.
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// defaults: { clave: valorPorDefecto }. Todos los valores son strings.
export default function useUrlParams(defaults) {
  const [searchParams, setSearchParams] = useSearchParams();

  const values = useMemo(() => {
    const out = {};
    Object.keys(defaults).forEach(key => { out[key] = searchParams.get(key) ?? defaults[key]; });
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // patch: { clave: nuevoValor }. Varios cambios en una sola llamada: el
  // updater de React Router no se encadena entre llamadas del mismo ciclo.
  const update = useCallback(patch => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      Object.entries(patch).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '' || value === defaults[key]) next.delete(key);
        else next.set(key, String(value));
      });
      return next;
    }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSearchParams]);

  return [values, update];
}
